import React from 'react';
import { useAuth } from './context/auth-context';
import { LoadingOverlay, useMantineTheme } from '@mantine/core';
import './App.css';

const AuthenticatedApp = React.lazy(() => import('./authenticated-app'));
const UnAuthenticatedApp = React.lazy(() => import('./unauthenticated-app'));

/**TODO: Have an un-authorized page, in-place of UnAuthenticatedApp
 * which will be used to show user is unothrized, it will be used to
 * ask user to authenticate by refreshing the page
 */
function App() {
  const { systemUser } = useAuth();
  const theme = useMantineTheme();
  return (
    <React.Suspense fallback={<LoadingOverlay visible={true} loaderProps={{ color: theme.colors.secondaryColors[0] }} />}>
      {systemUser?._id ? (
        <AuthenticatedApp />
      ) : systemUser === 0 ? (
        <UnAuthenticatedApp />
      ) : (
        <LoadingOverlay visible={true} loaderProps={{ color: theme.colors.secondaryColors[0] }} />
      )}
    </React.Suspense>
  );
}

export default App;
